module.exports = __webpack_public_path__ + "media/newstyle/images/services-footer-5-bf26c9156313285d29a74ba09d500dc5.png";